<ifc-base-dialog title="Broker API created"
                 [actions]="actions"
                 (actionClicked)="onActionClicked($event)">
  <ng-template #content>
    <p class="secondary-text sub-title">
      This message will only be displayed once. Save the information below in a
      secure place.
    </p>
    <div class="content">
      <div fxLayout="row wrap"
           fxFlex="100">
        <div *ngIf="data.apiKey?.id"
             fxLayout="column"
             fxFlex.gt-sm="100">
          <mat-form-field appearance="outline">
            <mat-label>Client ID</mat-label>
            <input class="copy-input"
                   matInput
                   value="{{ data.apiKey.clientId }}"
                   type="text"
                   [readonly]="true" />
            <button mat-icon-button
                    matSuffix
                    aria-label="Copy client ID button"
                    (click)="copy(data.apiKey.clientId)">
              <mat-icon>content_copy</mat-icon>
            </button>
          </mat-form-field>
        </div>
  
        <div *ngIf="data.apiKey?.id"
             fxLayout="column"
             fxFlex.gt-sm="100">
          <mat-form-field appearance="outline">
            <mat-label>Client secret</mat-label>
            <input class="copy-input"
                   matInput
                   value="{{ data.apiKey.clientSecret }}"
                   type="text"
                   [readonly]="true" />
            <button mat-icon-button
                    matSuffix
                    aria-label="Copy client secret button"
                    (click)="copy(data.apiKey.clientSecret)">
              <mat-icon>content_copy</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
    </div>
  </ng-template>
